// @generated by TypeGen from LogbookApi/ShipApi.swift - DO NOT EDIT

import type { ILocalShip } from "../LogbookApp/AppState"
import type { IAppResponse } from "../LogbookApp/Routes"
import type { IAppShipSelectRequest, ICompanionConnectionsResponse, ILocalShipConnectRequest, ILocalShipDisconnectRequest, ILocalShipHandoffResponse, ILocalShipResolveResponse, ILocalShipsResponse, IShipAutocompleteResponse, IShipResyncStatusResponse } from "../LogbookApp/ShipApi"
import type { INoteAttachmentsResponse } from "../LogbookModel/NoteAttachment"
import type { ISessionResponse } from "../LogbookModel/Session"
import type { IShipResponse, IShipsResponse } from "../LogbookModel/Ship"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import type { IShipCreateRequest, IShipImportResponse } from "../LogbookServer/ShipApi"
import type { ISuccessResponse } from "../LogbookServer/SuccessResponse"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface IShipSelectRequest {
  close: boolean;
}

export interface IShipSelectResponse {
  success: boolean;
  clientToken?: string;
}

export interface ShipApiEndpoints {
  "DELETE /api/ships/:shipId/companions/:companionId": {
    params: { shipId: number; companionId: string };
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "DELETE /api/ships/:shipId/import": {
    params: { shipId: number };
    query: {};
    request: never;
    response: ISuccessResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "DELETE /api/ships/:shipId/local": {
    params: { shipId: number };
    query: {};
    request: ILocalShipDisconnectRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "GET /api/ship/companion": {
    params: {};
    query: {};
    request: never;
    response: ILocalShip;
    targets: ApiTarget[];
    permission: {};
  };
  "GET /api/ship/resync/status": {
    params: {};
    query: {};
    request: never;
    response: IShipResyncStatusResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "GET /api/ships": {
    params: {};
    query: {};
    request: never;
    response: IShipsResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "GET /api/ships/:shipId": {
    params: { shipId: number };
    query: {};
    request: never;
    response: IShipResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/attachments": {
    params: { shipId: number };
    query: {};
    request: never;
    response: INoteAttachmentsResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "GET /api/ships/:shipId/autocomplete/:field": {
    params: { shipId: number; field: string };
    query: {};
    request: never;
    response: IShipAutocompleteResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/companions": {
    params: { shipId: number };
    query: {};
    request: never;
    response: ICompanionConnectionsResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/local/resolve": {
    params: { shipId: number };
    query: {};
    request: never;
    response: ILocalShipResolveResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "GET /api/ships/local": {
    params: {};
    query: {};
    request: never;
    response: ILocalShipsResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "GET /ships/:shipId/attachments/:attachmentId/download": {
    params: { shipId: number; attachmentId: number };
    query: {};
    request: never;
    response: Blob;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/ship": {
    params: {};
    query: {};
    request: IAppShipSelectRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "POST /api/ship/reset/cloud": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "POST /api/ship/reset/local": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "POST /api/ship/start": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/ships": {
    params: {};
    query: {};
    request: IShipCreateRequest;
    response: IShipResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "POST /api/ships/:shipId/import": {
    params: { shipId: number };
    query: {};
    request: { attachment: File };
    response: IShipImportResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ships/:shipId/local": {
    params: { shipId: number };
    query: {};
    request: ILocalShipConnectRequest;
    response: ISessionResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "POST /api/ships/:shipId/local/handoff": {
    params: { shipId: number };
    query: {};
    request: never;
    response: ILocalShipHandoffResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "PUT /api/ships/:shipId": {
    params: { shipId: number };
    query: {};
    request: IShipSelectRequest;
    response: IShipSelectResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const shipApiEndpoints = {
  "DELETE /api/ships/:shipId/companions/:companionId": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "DELETE /api/ships/:shipId/import": { targets: ["server"], permission: { ship: IShipUserLevel.primary } },
  "DELETE /api/ships/:shipId/local": { targets: ["app"], permission: { session: true } },
  "GET /api/ship/companion": { targets: ["app"], permission: {} },
  "GET /api/ship/resync/status": { targets: ["app"], permission: { session: true } },
  "GET /api/ships": { targets: ["app", "server"], permission: { session: true } },
  "GET /api/ships/:shipId": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewCurrent } },
  "GET /api/ships/:shipId/attachments": { targets: ["app", "server"], permission: { session: true } },
  "GET /api/ships/:shipId/autocomplete/:field": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "GET /api/ships/:shipId/companions": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "GET /api/ships/:shipId/local/resolve": { targets: ["app"], permission: { session: true } },
  "GET /api/ships/local": { targets: ["app"], permission: { session: true } },
  "GET /ships/:shipId/attachments/:attachmentId/download": { targets: ["app"], permission: {} },
  "POST /api/ship": { targets: ["app"], permission: { session: true } },
  "POST /api/ship/reset/cloud": { targets: ["app"], permission: { session: true } },
  "POST /api/ship/reset/local": { targets: ["app"], permission: { session: true } },
  "POST /api/ship/start": { targets: ["app"], permission: {} },
  "POST /api/ships": { targets: ["server"], permission: { session: true } },
  "POST /api/ships/:shipId/import": { targets: ["server"], permission: { ship: IShipUserLevel.primary } },
  "POST /api/ships/:shipId/local": { targets: ["app"], permission: { session: true } },
  "POST /api/ships/:shipId/local/handoff": { targets: ["app"], permission: { session: true } },
  "PUT /api/ships/:shipId": { targets: ["server"], permission: { ship: IShipUserLevel.primary } },
} as const;

export class ShipApi {
  constructor(private client: ApiClient) {}

  ships = {
    disconnectCompanion: (a: ApiArgs<ShipApiEndpoints, "DELETE /api/ships/:shipId/companions/:companionId">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "DELETE /api/ships/:shipId/companions/:companionId", shipApiEndpoints["DELETE /api/ships/:shipId/companions/:companionId"].targets);
        return this.client.call<IAppResponse>("DELETE /api/ships/:shipId/companions/:companionId", a);
      },
      url: (): string => this.client.url("DELETE /api/ships/:shipId/companions/:companionId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
    deleteImport: (a: ApiArgs<ShipApiEndpoints, "DELETE /api/ships/:shipId/import">) => ({
      call: (): Promise<ISuccessResponse> => {
        assertTarget(this.client, "DELETE /api/ships/:shipId/import", shipApiEndpoints["DELETE /api/ships/:shipId/import"].targets);
        return this.client.call<ISuccessResponse>("DELETE /api/ships/:shipId/import", a);
      },
      url: (): string => this.client.url("DELETE /api/ships/:shipId/import", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
    disconnectLocal: (a: ApiArgs<ShipApiEndpoints, "DELETE /api/ships/:shipId/local">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "DELETE /api/ships/:shipId/local", shipApiEndpoints["DELETE /api/ships/:shipId/local"].targets);
        return this.client.call<IAppResponse>("DELETE /api/ships/:shipId/local", a);
      },
      url: (): string => this.client.url("DELETE /api/ships/:shipId/local", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    companion: (a: ApiArgs<ShipApiEndpoints, "GET /api/ship/companion">) => ({
      call: (): Promise<ILocalShip> => {
        assertTarget(this.client, "GET /api/ship/companion", shipApiEndpoints["GET /api/ship/companion"].targets);
        return this.client.call<ILocalShip>("GET /api/ship/companion", a);
      },
      url: (): string => this.client.url("GET /api/ship/companion", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    resyncStatus: (a: ApiArgs<ShipApiEndpoints, "GET /api/ship/resync/status">) => ({
      call: (): Promise<IShipResyncStatusResponse> => {
        assertTarget(this.client, "GET /api/ship/resync/status", shipApiEndpoints["GET /api/ship/resync/status"].targets);
        return this.client.call<IShipResyncStatusResponse>("GET /api/ship/resync/status", a);
      },
      url: (): string => this.client.url("GET /api/ship/resync/status", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    list: (a: ApiArgs<ShipApiEndpoints, "GET /api/ships">) => ({
      call: (): Promise<IShipsResponse> => {
        assertTarget(this.client, "GET /api/ships", shipApiEndpoints["GET /api/ships"].targets);
        return this.client.call<IShipsResponse>("GET /api/ships", a);
      },
      url: (): string => this.client.url("GET /api/ships", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    get: (a: ApiArgs<ShipApiEndpoints, "GET /api/ships/:shipId">) => ({
      call: (): Promise<IShipResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId", shipApiEndpoints["GET /api/ships/:shipId"].targets);
        return this.client.call<IShipResponse>("GET /api/ships/:shipId", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    attachments: (a: ApiArgs<ShipApiEndpoints, "GET /api/ships/:shipId/attachments">) => ({
      call: (): Promise<INoteAttachmentsResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/attachments", shipApiEndpoints["GET /api/ships/:shipId/attachments"].targets);
        return this.client.call<INoteAttachmentsResponse>("GET /api/ships/:shipId/attachments", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/attachments", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    autocomplete: (a: ApiArgs<ShipApiEndpoints, "GET /api/ships/:shipId/autocomplete/:field">) => ({
      call: (): Promise<IShipAutocompleteResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/autocomplete/:field", shipApiEndpoints["GET /api/ships/:shipId/autocomplete/:field"].targets);
        return this.client.call<IShipAutocompleteResponse>("GET /api/ships/:shipId/autocomplete/:field", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/autocomplete/:field", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    companions: (a: ApiArgs<ShipApiEndpoints, "GET /api/ships/:shipId/companions">) => ({
      call: (): Promise<ICompanionConnectionsResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/companions", shipApiEndpoints["GET /api/ships/:shipId/companions"].targets);
        return this.client.call<ICompanionConnectionsResponse>("GET /api/ships/:shipId/companions", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/companions", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
    resolveLocal: (a: ApiArgs<ShipApiEndpoints, "GET /api/ships/:shipId/local/resolve">) => ({
      call: (): Promise<ILocalShipResolveResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/local/resolve", shipApiEndpoints["GET /api/ships/:shipId/local/resolve"].targets);
        return this.client.call<ILocalShipResolveResponse>("GET /api/ships/:shipId/local/resolve", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/local/resolve", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    local: (a: ApiArgs<ShipApiEndpoints, "GET /api/ships/local">) => ({
      call: (): Promise<ILocalShipsResponse> => {
        assertTarget(this.client, "GET /api/ships/local", shipApiEndpoints["GET /api/ships/local"].targets);
        return this.client.call<ILocalShipsResponse>("GET /api/ships/local", a);
      },
      url: (): string => this.client.url("GET /api/ships/local", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    attachmentDownload: (a: ApiArgs<ShipApiEndpoints, "GET /ships/:shipId/attachments/:attachmentId/download">) => ({
      call: (): Promise<Blob> => {
        assertTarget(this.client, "GET /ships/:shipId/attachments/:attachmentId/download", shipApiEndpoints["GET /ships/:shipId/attachments/:attachmentId/download"].targets);
        return this.client.call<Blob>("GET /ships/:shipId/attachments/:attachmentId/download", a);
      },
      url: (): string => this.client.url("GET /ships/:shipId/attachments/:attachmentId/download", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    selectApp: (a: ApiArgs<ShipApiEndpoints, "POST /api/ship">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship", shipApiEndpoints["POST /api/ship"].targets);
        return this.client.call<IAppResponse>("POST /api/ship", a);
      },
      url: (): string => this.client.url("POST /api/ship", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    resetCloud: (a: ApiArgs<ShipApiEndpoints, "POST /api/ship/reset/cloud">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/reset/cloud", shipApiEndpoints["POST /api/ship/reset/cloud"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/reset/cloud", a);
      },
      url: (): string => this.client.url("POST /api/ship/reset/cloud", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    resetLocal: (a: ApiArgs<ShipApiEndpoints, "POST /api/ship/reset/local">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/reset/local", shipApiEndpoints["POST /api/ship/reset/local"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/reset/local", a);
      },
      url: (): string => this.client.url("POST /api/ship/reset/local", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    start: (a: ApiArgs<ShipApiEndpoints, "POST /api/ship/start">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/ship/start", shipApiEndpoints["POST /api/ship/start"].targets);
        return this.client.call<IAppResponse>("POST /api/ship/start", a);
      },
      url: (): string => this.client.url("POST /api/ship/start", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    create: (a: ApiArgs<ShipApiEndpoints, "POST /api/ships">) => ({
      call: (): Promise<IShipResponse> => {
        assertTarget(this.client, "POST /api/ships", shipApiEndpoints["POST /api/ships"].targets);
        return this.client.call<IShipResponse>("POST /api/ships", a);
      },
      url: (): string => this.client.url("POST /api/ships", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    import: (a: ApiArgs<ShipApiEndpoints, "POST /api/ships/:shipId/import">) => ({
      call: (): Promise<IShipImportResponse> => {
        assertTarget(this.client, "POST /api/ships/:shipId/import", shipApiEndpoints["POST /api/ships/:shipId/import"].targets);
        return this.client.call<IShipImportResponse>("POST /api/ships/:shipId/import", a);
      },
      url: (): string => this.client.url("POST /api/ships/:shipId/import", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
    connectLocal: (a: ApiArgs<ShipApiEndpoints, "POST /api/ships/:shipId/local">) => ({
      call: (): Promise<ISessionResponse> => {
        assertTarget(this.client, "POST /api/ships/:shipId/local", shipApiEndpoints["POST /api/ships/:shipId/local"].targets);
        return this.client.call<ISessionResponse>("POST /api/ships/:shipId/local", a);
      },
      url: (): string => this.client.url("POST /api/ships/:shipId/local", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    prepareHandoff: (a: ApiArgs<ShipApiEndpoints, "POST /api/ships/:shipId/local/handoff">) => ({
      call: (): Promise<ILocalShipHandoffResponse> => {
        assertTarget(this.client, "POST /api/ships/:shipId/local/handoff", shipApiEndpoints["POST /api/ships/:shipId/local/handoff"].targets);
        return this.client.call<ILocalShipHandoffResponse>("POST /api/ships/:shipId/local/handoff", a);
      },
      url: (): string => this.client.url("POST /api/ships/:shipId/local/handoff", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    select: (a: ApiArgs<ShipApiEndpoints, "PUT /api/ships/:shipId">) => ({
      call: (): Promise<IShipSelectResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId", shipApiEndpoints["PUT /api/ships/:shipId"].targets);
        return this.client.call<IShipSelectResponse>("PUT /api/ships/:shipId", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
  };
}
